import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from 'react';
import type { Creative } from '../offerDrawer/creatives/types';

type ContextValue = {
  isOpen: boolean;
  creative: Creative | null;
  openDrawer: (creative: Creative) => void;
  closeDrawer: () => void;
};

const Ctx = createContext<ContextValue | null>(null);

export function OfferCreativeDrawerProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [creative, setCreative] = useState<Creative | null>(null);

  const openDrawer = useCallback((c: Creative) => {
    setCreative(c);
    setIsOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => setCreative(null), 300);
  }, []);

  return (
    <Ctx.Provider value={{ isOpen, creative, openDrawer, closeDrawer }}>
      {children}
    </Ctx.Provider>
  );
}

export function useOfferCreativeDrawer(): ContextValue {
  const ctx = useContext(Ctx);
  if (!ctx)
    throw new Error(
      'useOfferCreativeDrawer must be used within OfferCreativeDrawerProvider'
    );
  return ctx;
}
